import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Textbox.es.js";
const e = o.forwardRef((t, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...t, weights: m }));
e.displayName = "TextboxIcon";
const x = e;
export {
  x as Textbox,
  e as TextboxIcon
};
